import React from "react";
import { useState } from "react";
import { PageMode } from "utils/constant";
import TableComponent from "./components/TableComponent";
import DetailComponent from "./components/DetailComponent";
import "./index.scss";

const NotifikasiPEFeedback = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);

  const changePageMode = (page) => {
    setPageMode(page);
  };

  return (
    <div className="dashboard-wrapper">
      {pageMode === PageMode.view && (
        <TableComponent changeMode={changePageMode} />
      )}
      {pageMode === PageMode.detail && (
        <DetailComponent changeMode={changePageMode} />
      )}
    </div>
  );
};

export default NotifikasiPEFeedback;
